import { SuiteSankeyData } from './import/Types'
import { ApplySaveJSONDialog } from './import/OpenSankey'
import { TFunction } from 'i18next'
import {CheckCurrentViewSaved} from 'sankeyanimation/dist/src/SankeyPlusViews'
import {SankeyDevClickSaveDiagram,SankeyDevInputDialogSaveJSON} from 'sankeydev/dist/src/SankeyDevMenuDialog'
import React, { useState } from 'react'
import { ClickSaveDiagram } from 'open-sankey/dist/dialogs/SankeyPersistence'
import * as SankeyViews from 'sankeyanimation/dist/src/SankeyPlusViews'
import { dict_hook_ref_setter_show_dialog_componentsType } from 'open-sankey/src/types/Types'

declare const window: Window &
   typeof globalThis & {
    SankeyToolsStatic: boolean
   }

type SankeyDialogeSaveJSONTypes = {
  connected:boolean,
  data: SuiteSankeyData,
//   ref_setter_show_save_json: boolean,
  // set_show_save_json: (b:boolean)=>void,
  dict_hook_ref_setter_show_dialog_components:dict_hook_ref_setter_show_dialog_componentsType,
  t:TFunction,
  view:string,
  view_not_saved:string,
  set_view_not_saved:(s:string)=>void,
  master_data: SuiteSankeyData,

}


export const SankeySuiteDialogSaveJSON = (
  {connected,
    data,dict_hook_ref_setter_show_dialog_components,
    t,
    view,
    view_not_saved,set_view_not_saved,
    master_data}
    :SankeyDialogeSaveJSONTypes
)=>{
  const [to_beautify,set_to_beautify]=useState(false)
  const [save_only_view,set_save_only_view]=useState(false)

  let saved=true
  const {ref_getter_show_save_json}=dict_hook_ref_setter_show_dialog_components
  if(view !== 'none' && ref_getter_show_save_json.current && connected){
    const diff=CheckCurrentViewSaved(master_data,data,master_data.current_view)
    if(diff.length>0 && !window.SankeyToolsStatic){
      saved=false
      set_view_not_saved(view)
    }
  }

  const additional_input_save_json=[]as JSX.Element[]
  additional_input_save_json.push(SankeyDevInputDialogSaveJSON(t,to_beautify,set_to_beautify))

  if(connected && master_data && master_data.current_view && master_data.current_view!=='none'){
    additional_input_save_json.push(
      SankeyViews.MenuEnregistrerView(master_data,t,save_only_view,set_save_only_view))
  }
  const data_to_save=master_data && master_data.current_view && master_data.current_view!=='none' && save_only_view ?data:master_data

  return saved && view_not_saved===''?<ApplySaveJSONDialog
    t={t}
    //     ref_setter_show_save_json={ref_setter_show_save_json}
    // set_show_save_json={set_show_save_json}
    dict_hook_ref_setter_show_dialog_components={dict_hook_ref_setter_show_dialog_components}
    sankey_data={data_to_save}
    additionnal_button_option_save_json={additional_input_save_json}
    ClickSaveDiagram={to_beautify?SankeyDevClickSaveDiagram:ClickSaveDiagram}
  />:<></>


}



